/**
 * `useMediaQuery('(min-width: 901px)')`: si la pantalla cumple la consulta.
 *
 * Sirve para las pantallas del personal que en escritorio pintan un
 * formulario INLINE y en el teléfono lo abren en un modal: el mismo
 * componente, montado en un lugar u otro. `useSyncExternalStore` y no un
 * `useState` + `useEffect`: se suscribe al `MediaQueryList` sin un primer
 * render desfasado, y el valor de servidor (`false`) deja el móvil como
 * default si algún día se renderiza fuera del navegador.
 */

import { useCallback, useSyncExternalStore } from 'react';

export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback((onChange: () => void) => {
    const mq = window.matchMedia(query);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
